import Cookies from 'js-cookie';

export const isLocalhost = () => {
    try {
        console.log('Localhost set');
        return (
            typeof window !== 'undefined' &&
            window.location.hostname === 'localhost'
        );
    } catch {
        console.log('Localhost not set');
        return false;
    }
};

export const getDomainOrigin = () => {
    try {
        if (window !== undefined) {
            if (window.location.hostname === 'localhost') {
                // Use HTTPS if frontend is on HTTPS, HTTP if on HTTP
                const { protocol } = window.location; // https: or http:
                const port = protocol === 'https:' ? '7443' : '7000'; // Use 7443 for HTTPS proxy
                return `${protocol}//localhost:${port}`;
            }
            return window.location.origin;
        }
        return 'https://www.acko.com';
    } catch (e) {
        console.error('domain error ', e);
        return 'https://www.acko.com';
    }
};

export const getServerHostDomain = (host?: string) => {
    try {
        if (host?.includes('localhost')) {
            return 'http://localhost:7000';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'tronix') {
            return 'https://tronix.acko.com';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'master') {
            return 'https://www.ackodev.com';
        }
        if (process.env.NEXT_PUBLIC_ENVIRONMENT === 'isnp') {
            return 'https://acko-isnp.ackodev.com';
        }
        return 'https://www.acko.com';
    } catch {
        return 'https://www.acko.com';
    }
};

export function getHeaders() {
    return {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json',
        'x-a-k': Cookies.get('x-a-k'),
        'x-a-t': Cookies.get('x-a-t'),
        'x-r-t': Cookies.get('x-r-t'),
    };
}

// Returns axios config for local proxy support (withCredentials for localhost)
export function getAxiosConfig() {
    return {
        headers: getHeaders(),
        withCredentials: isLocalhost(),
    };
}
